const r={CREDENTIAL_CREATION_ERROR:"Navigator.credentials creation error",CREDENTIAL_RETRIEVAL_ERROR:"Navigator.credentials retrieval error",RISK_SIGNALS_ERROR:"Error capturing Risk Signals"};export{r as PasskeyErrorTypes};
